import React, { useState, useEffect } from 'react';
import Loading from './Loading'
import useAxiosPrivate from "./hooks/useAxiosPrivate"
import InvestorSectorChart from "./InvestorSectorChart"
import UpArrow from "./icon/UpArrow"
import DownArrow from "./icon/DownArrow"



function Holdings(props) {
    window.scrollTo(0, 0)
    document.title = "Nivesh Karma Gurus: Holding Insights";
    const [pageData, setpageData] = useState({});
    const [param, setParam] = useState("ho");
    const axiosPrivate = useAxiosPrivate();
    const companyDetails = async () => {
        setpageData({})
        let url = ""
        url = process.env.REACT_APP_BASE_URL + "/v1/investor-insights?access_token=" + process.env.REACT_APP_DATA_API_SECRET_KEY;

        const cdresponse = await axiosPrivate.get(url);
        localStorage.setItem("TableData", JSON.stringify(cdresponse.data))
        setpageData(cdresponse.data)
    }
    const getUrl = (url) => {
        return "/CompanyInvestor/" + url
    }
 

    const SortIndicator = (indicator) => {
        const sortData = JSON.parse(localStorage.getItem('SortData'))
        const SortDataItem = localStorage.getItem('SortDataItem')
        if (indicator === SortDataItem) {
            if (sortData["pointer"]) {
                return [true, true]
            } else {
                return [true, false]
            }
        }
        return [false, false]
    }

    const showSorted = (pointer) => {
        const sortData = JSON.parse(localStorage.getItem('SortData'))
        if (sortData !== null) {
            if (Object.keys(sortData).includes('pointer')) {
                if (sortData["pointer"]) {
                    localStorage.setItem("SortData", JSON.stringify({ pointer: false }));
                    localStorage.setItem("SortDataItem", pointer);
                } else {
                    localStorage.setItem("SortData", JSON.stringify({ pointer: true }));
                    localStorage.setItem("SortDataItem", pointer);
                }
            } else {
                localStorage.setItem("SortData", JSON.stringify({ pointer: true }));
                localStorage.setItem("SortDataItem", pointer);
            }
        } else {
            localStorage.setItem("SortData", JSON.stringify({ pointer: true }));
            localStorage.setItem("SortDataItem", pointer);
        }
        const finalSortData = JSON.parse(localStorage.getItem('SortData'))

        const itemsData = JSON.parse(localStorage.getItem('TableData'))
        let tempData = []
        if (param === "ho") {
            tempData = itemsData["holdings"]
        }
        if (param === "qb") {
            tempData = itemsData["quarterly_buys"]
        }
        if (param === "sb") {
            tempData = itemsData["six_month_buys"]
        }
        if (param === "qs") {
            tempData = itemsData["quarterly_sells"]
        }
        if (param === "ss") {
            tempData = itemsData["six_month_sells"]
        }
        console.log(tempData)
        if (finalSortData["pointer"]) {
            if (['sector', 'industry', 'activity'].includes(pointer[0])) {
                tempData.sort(dynamicSortAscendingString(pointer));
            } else {
                tempData.sort(dynamicSortAscending(pointer));
            }
        } else {
            if (['sector', 'industry', 'activity'].includes(pointer[0])) {
                tempData.sort(dynamicSortDescendingString(pointer));
            } else {
                tempData.sort(dynamicSortDescending(pointer));
            }
        }
        let finalData = itemsData
        if (param === "ho") {
            finalData["holdings"] = tempData
        }
        if (param === "qb") {
            finalData["quarterly_buys"] = tempData
        }
        if (param === "sb") {
            finalData["six_month_buys"] = tempData
        }
        if (param === "qs") {
            finalData["quarterly_sells"] = tempData
        }
        if (param === "ss") {
            finalData["six_month_sells"] = tempData
        }
        setpageData(finalData)
    }

    function forceDefault(data) {
        if (data === "-") {
            return 0
        } else {
            return data
        }
    }

    function dynamicSortDescending(property) {
        var sortOrder = 1;
        if (property[0] === "-") {
            sortOrder = -1;
            property = property.substr(1);
        }
        return function (a, b) {
            /* next line works with strings and numbers, 
             * and you may want to customize it to your needs
             */
            var result = (parseFloat(forceDefault(a[property])) > parseFloat(forceDefault(b[property]))) ? -1 : (parseFloat(forceDefault(a[property])) < parseFloat(forceDefault(b[property]))) ? 1 : 0;
            return result * sortOrder;
        }
    }


    function dynamicSortAscending(property) {
        var sortOrder = 1;
        if (property[0] === "-") {
            sortOrder = -1;
            property = property.substr(1);
        }
        return function (a, b) {
            /* next line works with strings and numbers, 
             * and you may want to customize it to your needs
             */
            var result = (parseFloat(forceDefault(a[property])) < parseFloat(forceDefault(b[property]))) ? -1 : (parseFloat(forceDefault(a[property])) > parseFloat(forceDefault(b[property]))) ? 1 : 0;
            return result * sortOrder;
        }
    }


    function dynamicSortDescendingString(property) {
        console.log("inside sort")
        var sortOrder = 1;
        if (property[0] === "-") {
            sortOrder = -1;
            property = property.substr(1);
        }
        return function (a, b) {
            /* next line works with strings and numbers, 
             * and you may want to customize it to your needs
             */
            var result = (String(a[property]) > String(b[property])) ? -1 : (String(a[property]) < String(b[property])) ? 1 : 0;
            return result * sortOrder;
        }
    }


    function dynamicSortAscendingString(property) {
        var sortOrder = 1;
        if (property[0] === "-") {
            sortOrder = -1;
            property = property.substr(1);
        }
        return function (a, b) {
            /* next line works with strings and numbers, 
             * and you may want to customize it to your needs
             */
            var result = (String(a[property]) < String(b[property])) ? -1 : (String(a[property]) > String(b[property])) ? 1 : 0;
            return result * sortOrder;
        }
    } 

    useEffect(() => {
        companyDetails()
    }, [param])


    return (
        <div className="Home" style={{ backgroundColor: "rgb(248, 248, 252)", fontSize: "14px", minHeight: "650px", marginLeft: "10px", marginRight: "10px", paddingBottom: "110px", paddingTop: "90px" }}>
            <div style={{ padding: "5px 110px" }}>
                <div className="CompanyNav" style={{ padding: "10px 0px 0px 0px" }}>

                    <div className="CompanyMenu" id="current" onClick={() => {
                        setParam('ho')
                    }
                    } style={param === "ho" ? { backgroundColor: '#000', color: '#fff' } : { backgroundColor: "rgb(221, 219, 240)", color: '#3e424b' }}>Holdings</div>
                    <div className="CompanyMenu" id="Activity" onClick={() => {
                        setParam('qb')
                    }
                    } style={param === "qb" ? { backgroundColor: '#000', color: '#fff' } : { backgroundColor: "rgb(221, 219, 240)", color: '#3e424b' }}>Quarter buys</div>
                    <div className="CompanyMenu" id="History" onClick={() => {
                        setParam('sb')
                    }
                    } style={param === "sb" ? { backgroundColor: '#000', color: '#fff' } : { backgroundColor: "rgb(221, 219, 240)", color: '#3e424b' }}>6 months buys</div>
                    <div className="CompanyMenu" id="History" onClick={() => {
                        setParam('qs')
                    }
                    } style={param === "qs" ? { backgroundColor: '#000', color: '#fff' } : { backgroundColor: "rgb(221, 219, 240)", color: '#3e424b' }}>Quarter sells</div>
                    
                    <div className="CompanyMenu" id="History" onClick={() => {
                        setParam('ss')
                    }
                    } style={param === "ss" ? { backgroundColor: '#000', color: '#fff' } : { backgroundColor: "rgb(221, 219, 240)", color: '#3e424b' }}>6 months sells</div>
                    <div className="CompanyMenu" id="History" onClick={() => {
                        setParam('si')
                    }
                    } style={param === "si" ? { backgroundColor: '#000', color: '#fff' } : { backgroundColor: "rgb(221, 219, 240)", color: '#3e424b' }}>Sector stats</div>

                </div>
            </div>
            <div>
                {Object.keys(pageData).length > 0 && param !== "si" &&
                    <div style={{ padding: "10px 110px 30px 110px" }}>

                        <div style={{ overflowX: "auto", backgroundColor: "white", borderRadius: "10px" }}>

                            <table className="PeersTable finData" style={{ width: "100%" }}>

                                <tbody>
                                    <tr>
                                        <td className="columnHeading" style={{ maxWidth: "100%", whiteSpace: "nowrap", textAlign: "center", paddingLeft: "10px", fontWeight: "500" }}>Symbol</td>
                                        <td className="columnHeading" style={{ maxWidth: "100%", whiteSpace: "nowrap", textAlign: "left", fontWeight: "500" }}>Company</td>
                                    <td className="columnHeading" style={{ maxWidth: "100%", whiteSpace: "nowrap", textAlign: "center", fontWeight: "500" }}>
                                        <div style={{ cursor: "pointer", color: "blue", display: "flex", justifyContent: "center", paddingTop: "5px" }} onClick={() => showSorted(['investor_count'])}>
                                            <div>
                                                Investor count
                                            </div>
                                            <div style={{ paddingTop: "5px" }}>
                                                {SortIndicator("investor_count")[0] ? <div>{SortIndicator("investor_count")[1] ? <DownArrow /> : < UpArrow />}</div> : <div style={{ minHeight: "25px" }}>&nbsp;</div>}
                                            </div>
                                        </div>
                                    </td>
                                    <td className="columnHeading" style={{ textAlign: "left", whiteSpace: "nowrap", paddingLeft: "10px", textAlign: "center", fontWeight: "500" }}>
                                        <div style={{ cursor: "pointer", color: "blue", display: "flex", justifyContent: "center", paddingTop: "5px" }} onClick={() => showSorted(['current_price'])}>
                                            <div>
                                                Price
                                            </div>
                                            <div style={{ paddingTop: "5px" }}>
                                                {SortIndicator("current_price")[0] ? <div>{SortIndicator("current_price")[1] ? <DownArrow /> : < UpArrow />}</div> : <div style={{ minHeight: "25px" }}>&nbsp;</div>}
                                            </div>
                                        </div>
                                    </td>
                                    <td className="columnHeading" style={{ textAlign: "left", whiteSpace: "nowrap", paddingLeft: "10px", textAlign: "center", fontWeight: "500" }}>
                                        <div style={{ cursor: "pointer", color: "blue", display: "flex", justifyContent: "center", paddingTop: "5px" }} onClick={() => showSorted(['pct_above_low_52'])}>
                                            <div>
                                                % above 52w low
                                            </div>
                                            <div style={{ paddingTop: "5px" }}>
                                                {SortIndicator("pct_above_low_52")[0] ? <div>{SortIndicator("pct_above_low_52")[1] ? <DownArrow /> : < UpArrow />}</div> : <div style={{ minHeight: "25px" }}>&nbsp;</div>}
                                            </div>
                                        </div>
                                    </td>
                                    <td className="columnHeading" style={{ textAlign: "left", whiteSpace: "nowrap", paddingLeft: "10px", textAlign: "center", fontWeight: "500" }}>
                                        <div style={{ cursor: "pointer", color: "blue", display: "flex", justifyContent: "center", paddingTop: "5px" }} onClick={() => showSorted(['pct_below_high52'])}>
                                            <div>
                                                % below 52w high
                                            </div>
                                            <div style={{ paddingTop: "5px" }}>
                                                {SortIndicator("pct_below_high52")[0] ? <div>{SortIndicator("pct_below_high52")[1] ? <DownArrow /> : < UpArrow />}</div> : <div style={{ minHeight: "25px" }}>&nbsp;</div>}
                                            </div>
                                        </div>
                                    </td>
                                    <td className="columnHeading" style={{ textAlign: "left", whiteSpace: "nowrap", paddingLeft: "10px", textAlign: "center", fontWeight: "500" }}>
                                        
                                        <div style={{ cursor: "pointer", color: "blue", display: "flex", justifyContent: "center", paddingTop: "5px" }} onClick={() => showSorted(['low_52'])}>
                                            <div>
                                                52w low
                                            </div>
                                            <div style={{ paddingTop: "5px" }}>
                                                {SortIndicator("low_52")[0] ? <div>{SortIndicator("low_52")[1] ? <DownArrow /> : < UpArrow />}</div> : <div style={{ minHeight: "25px" }}>&nbsp;</div>}
                                            </div>
                                        </div>
                                    </td>
                                    <td className="columnHeading" style={{ textAlign: "left", whiteSpace: "nowrap", paddingLeft: "10px", textAlign: "center", fontWeight: "500" }}>
                                        
                                        <div style={{ cursor: "pointer", color: "blue", display: "flex", justifyContent: "center", paddingTop: "5px" }} onClick={() => showSorted(['high_52'])}>
                                            <div>
                                                52w high
                                            </div>
                                            <div style={{ paddingTop: "5px" }}>
                                                {SortIndicator("high_52")[0] ? <div>{SortIndicator("high_52")[1] ? <DownArrow /> : < UpArrow />}</div> : <div style={{ minHeight: "25px" }}>&nbsp;</div>}
                                            </div>
                                        </div>
                                    </td>
                                    <td className="columnHeading" style={{ textAlign: "left", whiteSpace: "nowrap", paddingLeft: "10px", textAlign: "center", fontWeight: "500" }}>
                                        
                                        <div style={{ cursor: "pointer", color: "blue", display: "flex", justifyContent: "center", paddingTop: "5px" }} onClick={() => showSorted(['sector'])}>
                                            <div>
                                                Sector
                                            </div>
                                            <div style={{ paddingTop: "5px" }}>
                                                {SortIndicator("sector")[0] ? <div>{SortIndicator("sector")[1] ? <DownArrow /> : < UpArrow />}</div> : <div style={{ minHeight: "25px" }}>&nbsp;</div>}
                                            </div>
                                        </div>
                                    </td>
                                    <td className="columnHeading" style={{ textAlign: "left", whiteSpace: "nowrap", paddingLeft: "10px", textAlign: "center", fontWeight: "500" }}>
                                        
                                        <div style={{ cursor: "pointer", color: "blue", display: "flex", justifyContent: "center", paddingTop: "5px" }} onClick={() => showSorted(['industry'])}>
                                            <div>
                                                Industry
                                            </div>
                                            <div style={{ paddingTop: "5px" }}>
                                                {SortIndicator("industry")[0] ? <div>{SortIndicator("industry")[1] ? <DownArrow /> : < UpArrow />}</div> : <div style={{ minHeight: "25px" }}>&nbsp;</div>}
                                            </div>
                                        </div>
                                    </td>
                                    </tr>
                                </tbody>

                                {Object.keys(pageData).length > 0 && param === "ho" &&

                                    <tbody>
                                        {pageData.holdings.map((holdingItem, index) => (
                                            <tr>
                                                <td className={index % 2 === 0 ? "tabledata SubHeader OddDiv" : "tabledata SubHeader"} style={{ maxWidth: "100%", whiteSpace: "nowrap", textAlign: "center", paddingLeft: "10px" }}><a href={getUrl(holdingItem.stock_symbol)} target="_blank" style={{ textDecoration: "none" }}>{holdingItem.stock_symbol}</a></td>
                                                <td className={index % 2 === 0 ? "tabledata SubHeader OddDiv" : "tabledata SubHeader"} style={{ maxWidth: "100%", whiteSpace: "nowrap", textAlign: "left" }}>{holdingItem.company_name}</td>
                                                <td className={index % 2 === 0 ? "tabledata SubHeader OddDiv" : "tabledata SubHeader"} style={{ maxWidth: "100%", whiteSpace: "nowrap", textAlign: "center" }}>{holdingItem.investor_count}</td>
                                                <td className={index % 2 === 0 ? "tabledata SubHeader OddDiv" : "tabledata SubHeader"} style={{ maxWidth: "100%", whiteSpace: "nowrap", textAlign: "center" }}>{holdingItem.current_price}</td>
                                                <td className={index % 2 === 0 ? "tabledata SubHeader OddDiv" : "tabledata SubHeader"} style={{ maxWidth: "100%", whiteSpace: "nowrap", textAlign: "center" }}>{holdingItem.pct_above_low_52}</td>
                                                <td className={index % 2 === 0 ? "tabledata SubHeader OddDiv" : "tabledata SubHeader"} style={{ maxWidth: "100%", whiteSpace: "nowrap", textAlign: "center" }}>{holdingItem.pct_below_high52}</td>
                                                <td className={index % 2 === 0 ? "tabledata SubHeader OddDiv" : "tabledata SubHeader"} style={{ maxWidth: "100%", whiteSpace: "nowrap", textAlign: "center" }}>{holdingItem.low_52}</td>
                                                <td className={index % 2 === 0 ? "tabledata SubHeader OddDiv" : "tabledata SubHeader"} style={{ maxWidth: "100%", whiteSpace: "nowrap", textAlign: "center" }}>{holdingItem.high_52}</td>
                                                <td className={index % 2 === 0 ? "tabledata SubHeader OddDiv" : "tabledata SubHeader"} style={{ maxWidth: "100%", whiteSpace: "nowrap", textAlign: "center" }}>{holdingItem.sector}</td>
                                                <td className={index % 2 === 0 ? "tabledata SubHeader OddDiv" : "tabledata SubHeader"} style={{ maxWidth: "100%", whiteSpace: "nowrap", textAlign: "center" }}>{holdingItem.industry}</td>
                                            </tr>
                                        ))}
                                    </tbody>
                                }



                                {Object.keys(pageData).length > 0 && param === "qb" &&
                                    <tbody>
                                        {pageData.quarterly_buys.map((holdingItem, index) => (
                                            <tr>
                                                <td className={index % 2 === 0 ? "tabledata SubHeader OddDiv" : "tabledata SubHeader"} style={{ maxWidth: "100%", whiteSpace: "nowrap", textAlign: "center", paddingLeft: "10px" }}><a href={getUrl(holdingItem.stock_symbol)} target="_blank" style={{ textDecoration: "none" }}>{holdingItem.stock_symbol}</a></td>
                                                <td className={index % 2 === 0 ? "tabledata SubHeader OddDiv" : "tabledata SubHeader"} style={{ maxWidth: "100%", whiteSpace: "nowrap", textAlign: "left" }}>{holdingItem.company_name}</td>
                                                <td className={index % 2 === 0 ? "tabledata SubHeader OddDiv" : "tabledata SubHeader"} style={{ maxWidth: "100%", whiteSpace: "nowrap", textAlign: "center" }}>{holdingItem.investor_count}</td>
                                                <td className={index % 2 === 0 ? "tabledata SubHeader OddDiv" : "tabledata SubHeader"} style={{ maxWidth: "100%", whiteSpace: "nowrap", textAlign: "center" }}>{holdingItem.current_price}</td>
                                                <td className={index % 2 === 0 ? "tabledata SubHeader OddDiv" : "tabledata SubHeader"} style={{ maxWidth: "100%", whiteSpace: "nowrap", textAlign: "center" }}>{holdingItem.pct_above_low_52}</td>
                                                <td className={index % 2 === 0 ? "tabledata SubHeader OddDiv" : "tabledata SubHeader"} style={{ maxWidth: "100%", whiteSpace: "nowrap", textAlign: "center" }}>{holdingItem.pct_below_high52}</td>
                                                <td className={index % 2 === 0 ? "tabledata SubHeader OddDiv" : "tabledata SubHeader"} style={{ maxWidth: "100%", whiteSpace: "nowrap", textAlign: "center" }}>{holdingItem.low_52}</td>
                                                <td className={index % 2 === 0 ? "tabledata SubHeader OddDiv" : "tabledata SubHeader"} style={{ maxWidth: "100%", whiteSpace: "nowrap", textAlign: "center" }}>{holdingItem.high_52}</td>
                                                <td className={index % 2 === 0 ? "tabledata SubHeader OddDiv" : "tabledata SubHeader"} style={{ maxWidth: "100%", whiteSpace: "nowrap", textAlign: "center" }}>{holdingItem.sector}</td>
                                                <td className={index % 2 === 0 ? "tabledata SubHeader OddDiv" : "tabledata SubHeader"} style={{ maxWidth: "100%", whiteSpace: "nowrap", textAlign: "center" }}>{holdingItem.industry}</td>
                                            </tr>
                                        ))}
                                    </tbody>
                                }


                                {Object.keys(pageData).length > 0 && param === "qs" &&
                                    <tbody>
                                        {pageData.quarterly_sells.map((holdingItem, index) => (
                                            <tr>
                                                <td className={index % 2 === 0 ? "tabledata SubHeader OddDiv" : "tabledata SubHeader"} style={{ maxWidth: "100%", whiteSpace: "nowrap", textAlign: "center", paddingLeft: "10px" }}><a href={getUrl(holdingItem.stock_symbol)} target="_blank" style={{ textDecoration: "none" }}>{holdingItem.stock_symbol}</a></td>
                                                <td className={index % 2 === 0 ? "tabledata SubHeader OddDiv" : "tabledata SubHeader"} style={{ maxWidth: "100%", whiteSpace: "nowrap", textAlign: "left" }}>{holdingItem.company_name}</td>
                                                <td className={index % 2 === 0 ? "tabledata SubHeader OddDiv" : "tabledata SubHeader"} style={{ maxWidth: "100%", whiteSpace: "nowrap", textAlign: "center" }}>{holdingItem.investor_count}</td>
                                                <td className={index % 2 === 0 ? "tabledata SubHeader OddDiv" : "tabledata SubHeader"} style={{ maxWidth: "100%", whiteSpace: "nowrap", textAlign: "center" }}>{holdingItem.current_price}</td>
                                                <td className={index % 2 === 0 ? "tabledata SubHeader OddDiv" : "tabledata SubHeader"} style={{ maxWidth: "100%", whiteSpace: "nowrap", textAlign: "center" }}>{holdingItem.pct_above_low_52}</td>
                                                <td className={index % 2 === 0 ? "tabledata SubHeader OddDiv" : "tabledata SubHeader"} style={{ maxWidth: "100%", whiteSpace: "nowrap", textAlign: "center" }}>{holdingItem.pct_below_high52}</td>
                                                <td className={index % 2 === 0 ? "tabledata SubHeader OddDiv" : "tabledata SubHeader"} style={{ maxWidth: "100%", whiteSpace: "nowrap", textAlign: "center" }}>{holdingItem.low_52}</td>
                                                <td className={index % 2 === 0 ? "tabledata SubHeader OddDiv" : "tabledata SubHeader"} style={{ maxWidth: "100%", whiteSpace: "nowrap", textAlign: "center" }}>{holdingItem.high_52}</td>
                                                <td className={index % 2 === 0 ? "tabledata SubHeader OddDiv" : "tabledata SubHeader"} style={{ maxWidth: "100%", whiteSpace: "nowrap", textAlign: "center" }}>{holdingItem.sector}</td>
                                                <td className={index % 2 === 0 ? "tabledata SubHeader OddDiv" : "tabledata SubHeader"} style={{ maxWidth: "100%", whiteSpace: "nowrap", textAlign: "center" }}>{holdingItem.industry}</td>
                                            </tr>
                                        ))}
                                    </tbody>
                                }


                                {Object.keys(pageData).length > 0 && param === "sb" &&
                                    <tbody>
                                        {pageData.six_month_buys.map((holdingItem, index) => (
                                            <tr>
                                                <td className={index % 2 === 0 ? "tabledata SubHeader OddDiv" : "tabledata SubHeader"} style={{ maxWidth: "100%", whiteSpace: "nowrap", textAlign: "center", paddingLeft: "10px" }}><a href={getUrl(holdingItem.stock_symbol)} target="_blank" style={{ textDecoration: "none" }}>{holdingItem.stock_symbol}</a></td>
                                                <td className={index % 2 === 0 ? "tabledata SubHeader OddDiv" : "tabledata SubHeader"} style={{ maxWidth: "100%", whiteSpace: "nowrap", textAlign: "left" }}>{holdingItem.company_name}</td>
                                                <td className={index % 2 === 0 ? "tabledata SubHeader OddDiv" : "tabledata SubHeader"} style={{ maxWidth: "100%", whiteSpace: "nowrap", textAlign: "center" }}>{holdingItem.investor_count}</td>
                                                <td className={index % 2 === 0 ? "tabledata SubHeader OddDiv" : "tabledata SubHeader"} style={{ maxWidth: "100%", whiteSpace: "nowrap", textAlign: "center" }}>{holdingItem.current_price}</td>
                                                <td className={index % 2 === 0 ? "tabledata SubHeader OddDiv" : "tabledata SubHeader"} style={{ maxWidth: "100%", whiteSpace: "nowrap", textAlign: "center" }}>{holdingItem.pct_above_low_52}</td>
                                                <td className={index % 2 === 0 ? "tabledata SubHeader OddDiv" : "tabledata SubHeader"} style={{ maxWidth: "100%", whiteSpace: "nowrap", textAlign: "center" }}>{holdingItem.pct_below_high52}</td>
                                                <td className={index % 2 === 0 ? "tabledata SubHeader OddDiv" : "tabledata SubHeader"} style={{ maxWidth: "100%", whiteSpace: "nowrap", textAlign: "center" }}>{holdingItem.low_52}</td>
                                                <td className={index % 2 === 0 ? "tabledata SubHeader OddDiv" : "tabledata SubHeader"} style={{ maxWidth: "100%", whiteSpace: "nowrap", textAlign: "center" }}>{holdingItem.high_52}</td>
                                                <td className={index % 2 === 0 ? "tabledata SubHeader OddDiv" : "tabledata SubHeader"} style={{ maxWidth: "100%", whiteSpace: "nowrap", textAlign: "center" }}>{holdingItem.sector}</td>
                                                <td className={index % 2 === 0 ? "tabledata SubHeader OddDiv" : "tabledata SubHeader"} style={{ maxWidth: "100%", whiteSpace: "nowrap", textAlign: "center" }}>{holdingItem.industry}</td>
                                            </tr>
                                        ))}
                                    </tbody>
                                }


                                {Object.keys(pageData).length > 0 && param === "ss" &&

                                    <tbody>
                                        {pageData.six_month_sells.map((holdingItem, index) => (
                                            <tr>
                                                <td className={index % 2 === 0 ? "tabledata SubHeader OddDiv" : "tabledata SubHeader"} style={{ maxWidth: "100%", whiteSpace: "nowrap", textAlign: "center", paddingLeft: "10px" }}><a href={getUrl(holdingItem.stock_symbol)} target="_blank" style={{ textDecoration: "none" }}>{holdingItem.stock_symbol}</a></td>
                                                <td className={index % 2 === 0 ? "tabledata SubHeader OddDiv" : "tabledata SubHeader"} style={{ maxWidth: "100%", whiteSpace: "nowrap", textAlign: "left" }}>{holdingItem.company_name}</td>
                                                <td className={index % 2 === 0 ? "tabledata SubHeader OddDiv" : "tabledata SubHeader"} style={{ maxWidth: "100%", whiteSpace: "nowrap", textAlign: "center" }}>{holdingItem.investor_count}</td>
                                                <td className={index % 2 === 0 ? "tabledata SubHeader OddDiv" : "tabledata SubHeader"} style={{ maxWidth: "100%", whiteSpace: "nowrap", textAlign: "center" }}>{holdingItem.current_price}</td>
                                                <td className={index % 2 === 0 ? "tabledata SubHeader OddDiv" : "tabledata SubHeader"} style={{ maxWidth: "100%", whiteSpace: "nowrap", textAlign: "center" }}>{holdingItem.pct_above_low_52}</td>
                                                <td className={index % 2 === 0 ? "tabledata SubHeader OddDiv" : "tabledata SubHeader"} style={{ maxWidth: "100%", whiteSpace: "nowrap", textAlign: "center" }}>{holdingItem.pct_below_high52}</td>
                                                <td className={index % 2 === 0 ? "tabledata SubHeader OddDiv" : "tabledata SubHeader"} style={{ maxWidth: "100%", whiteSpace: "nowrap", textAlign: "center" }}>{holdingItem.low_52}</td>
                                                <td className={index % 2 === 0 ? "tabledata SubHeader OddDiv" : "tabledata SubHeader"} style={{ maxWidth: "100%", whiteSpace: "nowrap", textAlign: "center" }}>{holdingItem.high_52}</td>
                                                <td className={index % 2 === 0 ? "tabledata SubHeader OddDiv" : "tabledata SubHeader"} style={{ maxWidth: "100%", whiteSpace: "nowrap", textAlign: "center" }}>{holdingItem.sector}</td>
                                                <td className={index % 2 === 0 ? "tabledata SubHeader OddDiv" : "tabledata SubHeader"} style={{ maxWidth: "100%", whiteSpace: "nowrap", textAlign: "center" }}>{holdingItem.industry}</td>
                                            </tr>
                                        ))}
                                    </tbody>
                                }

                            </table>
                        </div>
                    </div >
                }
                {Object.keys(pageData).length > 0 && param === "si" &&
                    <div style={{ padding: "10px 110px 30px 110px" }}>
                        <InvestorSectorChart investor="" sectorData={pageData.sector_by_pct} source="insight" />
                    </div>
                }
                {Object.keys(pageData).length === 0 &&
                    <div style={{ minHeight: "400px", paddingTop: "180px" }}>
                        <Loading />
                    </div>
                }

            </div>
        </div>
    );
}
export default Holdings;

